<button ion-item class="container-btn" (click)="onClick.emit()">
  <h2><span class="text-main">{{ item?.name }}</span></h2>
  <h2><span class="text-description">{{ item?.description }}</span></h2>
  <p *ngIf="item?.preround"><span class="text-prefix">Vorrunde:</span> {{ item.preround }}</p>
  <p *ngIf="item?.finalround"><span class="text-prefix">Endrunde:</span> {{ item.finalround }}</p>
  <p *ngIf="item?.finalstage"><span class="text-prefix">Endphase:</span> {{ item.finalstage }}</p>
  <p *ngIf="item?.place">{{ item?.place }}</p>
  <p *ngIf="item?.additional" class="text-additional">{{ item.additional }}</p>
</button>